$(document).ready(function() {
    $('input[type="radio"][name="properties[Handle Engraving]"]').change(function() {
        var selectedValue = $(this).val();
        if(selectedValue == 'Yes'){
            $('.custom-handle-group').show();
            $('.product-options-price-info').show();
            $('input[type="text"][name="properties[Handle 1]"]').prop('required', true);
            $('input[type="text"][name="properties[Handle 2]"]').prop('required', true);
            $('input[type="radio"][name="properties[Font Style]"]').prop('required', true);
            var main_id = $('input#custom-fit-name-id').val();
            var addon_id = $('input[type="radio"][name="properties[Handle Engraving]"]:checked').data('variant-id');
            $('input#custom-fit-name-id').after( `<input type="hidden" name="items[0][id]" value="`+addon_id+`">`);
            $('input#custom-fit-name-id').after( `<input type="hidden" name="items[0][parent_id]" value="`+main_id+`">`);
        }else{
            $('.custom-handle-group').hide();
            $('.product-options-price-info').hide();
            $('input[type="text"][name="properties[Handle 1]"]').prop('required', false);
            $('input[type="text"][name="properties[Handle 2]"]').prop('required', false);
            $('input[type="radio"][name="properties[Font Style]"]').prop('required', false);
            $('input[name="items[0][id]"]').remove();
            $('input[name="items[0][parent_id]"]').remove();
        }
    });

    /* var total_custom_band_colour = $('#total_custom_band_colour').val(); */
    var total_custom_band_colour = 1
    $('input[type="radio"][name="properties[Custom band colours?]"]').change(function() {
        var selectedValue = $(this).val();
        if(selectedValue == 'Yes'){
            $('.custom-band-colours [data-group-name="Bands"]').show();
            $('.product-options-price-info').show();
            
            var main_id = $('input#evo-name-id').val();
            var addon_id = $('input[type="radio"][name="properties[Custom band colours?]"]:checked').data('variant-id');
            $('input#evo-name-id').after( `<input type="hidden" name="items[0][id]" value="`+addon_id+`">`);
            $('input#evo-name-id').after( `<input type="hidden" name="items[0][parent_id]" value="`+main_id+`">`);
            if(total_custom_band_colour > 0){
                for (var i = 1; i <= total_custom_band_colour; i++) {
                    $('.custom-band-colours input[name="properties[Band colour]"]').prop('required', true);
                }
            }
        }else{
            $('.product-gallery__media-list .product-gallery__media.is-selected').find('.custom-band-colour').remove();
            $('.custom-band-colours [data-group-name="Bands"]').hide();
            $('.product-options-price-info').hide();
            $('input[name="items[0][id]"]').remove();
            $('input[name="items[0][parent_id]"]').remove();
            if(total_custom_band_colour > 0){
                for (var i = 1; i <= total_custom_band_colour; i++) {
                    $('.custom-band-colours input[name="properties[Band colour]"]').prop('required', false).prop('checked',false);
                }
            }
        }
    });

    if(total_custom_band_colour > 0){
        for (var i = 1; i <= total_custom_band_colour; i++) {
            var inputPropertiesBandColour = $('.custom-band-colours.evo-fre-speed-rope-black input[type="radio"][name="properties[Band colour]');
            inputPropertiesBandColour.change(function() {
                var selectedColor = $(this).val();
                var selectedIndex = $(this).data('index');
                for (var i = 1; i <= 6; i++) {
                    var bandColour = 'https://cdn.shopify.com/s/files/1/0383/7558/7975/files/Band-Colour-'+i+'-'+selectedColor+'.png?v=1761382688';
                    $('.product-gallery__media-list .product-gallery__media.is-selected').find('.custom-band-colour.band-colour-'+i+'').remove();
                    $('.product-gallery__media-list .product-gallery__media.is-selected').append('<img class="custom-band-colour band-colour-'+i+'" src="'+bandColour+'">');
                }
            });
        }
    }

    if($('.custom-band-colours.evo-g2-speed-rope-black').length > 0){
        var inputPropertiesBandColour = $('.custom-band-colours.evo-g2-speed-rope-black input[type="radio"][name="properties[Band colour]');
        inputPropertiesBandColour.change(function() {
            var selectedColor = $(this).val();
            if(selectedColor == 'Teal'){
                var bandColour = 'https://cdn.shopify.com/s/files/1/0383/7558/7975/files/G2-Teal.png?v=1764778070';
            }else{
                var bandColour = 'https://cdn.shopify.com/s/files/1/0383/7558/7975/files/G2-'+selectedColor+'.png?v=1764252583';
            }
            $('.product-gallery__media-list .product-gallery__media.is-selected').find('.custom-band-colour.g2-band-colour').remove();
            $('.product-gallery__media-list .product-gallery__media.is-selected').append('<img class="custom-band-colour g2-band-colour" src="'+bandColour+'">');
        });
    }

});